import script from "./DashboardBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardBarChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__